export default __webpack_public_path__ + "static/media/DSC44006.dac2e551.jpg";